export const EMPLOYEE_SENSITIVE_DATA_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/vault77/employeeSensitiveData`;
